<template>
  <div class="pt-1 pb-1 text-gray-900 dark:text-gray-400">
    <details
      v-for="contest in problemSearchModalStatePresenter.selectedContestList.value"
      :key="contest.abbr"
      class="my-2"
    >
      <summary
        class="hover-hand py-3 pr-4 pl-12 border rounded relative hover:shadow-md transition-shadow duration-150 hover:border-challenge dark:hover:border-challenge dark:border-dark-400 dark:text-dark-text dark:bg-dark-500"
        :class="isLightMode() ? 'arrow' : 'arrow-dark'"
      >
        <p>
          <span class="text-2xl font-bold mr-2 notranslate">
            {{ contest.abbr }}
          </span>
          <span class="text-base text-gray-500 dark:text-dark-text"> {{ contest.numberOfProblems }} problems </span>
        </p>
        <div class="flex items-center">
          <span class="text-base mr-2 text-gray-500 dark:text-dark-text"> {{ calc2digit(contest.progress) }}% </span>
          <base-progress-bar colorType="CHALLENGE" :num="calc2digit(contest.progress)" />
        </div>
      </summary>
      <div>
        <base-contest-day-card
          v-for="day in contest.days"
          :key="day.id"
          :contestDay="day"
          :onClick="id => clickProblem(contest.largeCl, contest.middleCl, id)"
        />
      </div>
    </details>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import BaseContestDayCard from './BaseContestDayCard.vue'
import BaseProgressBar from './BaseProgressBar.vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useProblemSearchModalStatePresenter } from '@/presentation/composables/problem/useProblemSearchModalStatePresenter'

export default defineComponent({
  components: {
    BaseProgressBar,
    BaseContestDayCard
  },
  props: {
    onClickProblem: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const problemSearchModalStatePresenter = useProblemSearchModalStatePresenter()
    const { isLightMode } = useConfigStatePresenter()

    const calc2digit = (num: number) => {
      return Math.floor((num + 0.005) * 100) / 100
    }

    const clickProblem = (lid: string, mid: string, id: string) => {
      props.onClickProblem(id, {
        largeCl: lid,
        middleCl: mid,
        problem: id
      })
    }

    return {
      calc2digit,
      clickProblem,
      isLightMode,
      problemSearchModalStatePresenter
    }
  }
})
</script>

<style scoped>
summary {
  display: block;
}

summary::-webkit-details-marker {
  display: none;
}

.arrow::before {
  content: '';
  position: absolute;
  top: 1.8rem;
  left: 1rem;
  width: 1rem;
  height: 1rem;
  border-top: 0.5rem solid white;
  border-bottom: 0.5rem solid white;
  border-left: 0.5rem solid #b0bec5;
  box-sizing: border-box;
  transition: 200ms;
}

details[open] .arrow::before {
  transform: rotate(90deg);
  left: 1rem;
  top: 1.8rem;
}

.arrow-dark::before {
  content: '';
  position: absolute;
  top: 1.8rem;
  left: 1rem;
  width: 1rem;
  height: 1rem;
  border-top: 0.5rem solid #2e2e2e;
  border-bottom: 0.5rem solid #2e2e2e;
  border-left: 0.5rem solid #b0bec5;
  box-sizing: border-box;
  transition: 200ms;
}

details[open] .arrow-dark::before {
  transform: rotate(90deg);
  left: 1rem;
  top: 1.8rem;
}
.hover-hand {
  cursor: pointer;
  cursor: hand;
}
</style>
